import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoArIL: CultureInfo = {
  name: 'ar-IL',
  displayName: 'العربية (إسرائيل)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-IL',
  parent: CultureInfoAr
};
